module.exports = __webpack_public_path__ + "static/media/subscription-success-trophy.aadc444c.png";